import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'left-side-menu',
    templateUrl: './left-side-menu.html',
    styleUrls: ['./left-side-menu.scss'],
})
export class LeftSideMenu implements OnInit {
    isMenuToggled: boolean = true;

    constructor(private router: Router) {}

    ngOnInit() { 
    }

    toggleLeftBar() {
        this.isMenuToggled = !this.isMenuToggled;

        document.getElementsByClassName('menu-carousel')[0].classList.toggle("toggled");
        document.getElementsByClassName('tactic-pitch')[0].classList.toggle("toggled");
        
    }

    gotoPlayersList() {
        this.router.navigate(['players']);
    }
}
